import { render, staticRenderFns } from "./RoleAssets.vue?vue&type=template&id=141bf6e7"
import script from "./RoleAssets.vue?vue&type=script&lang=js"
export * from "./RoleAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports